<template>
  <div>
    <el-dialog :title="$t('system.modify_withdraw_type')" class="diglog-card" :close-on-click-modal="false" :visible.sync="dialogVisible" width="550px" @close="handleDialogClose">
      <div class="header-line" />
      <div class="section-title">
        {{ $t('system.withdraw_details') }}
      </div>
      <div v-if="withdraw_fee_status === 1" class="section-tip">
        {{ $t('system.handling_fee') }}: {{ withdraw_fee | toDivideWithDot }} {{ $t('system.per_transaction') }}
      </div>
      <div v-if="posWithdrawConfigLocked" class="pos-withdraw-lock-tip">
        <i class="el-icon-warning-outline" /> {{ $t('system.pos_withdraw_config_locked') }}
      </div>
      <div class="modify-password">
        <el-form ref="form" :model="form" label-width="200px" label-position="top">
          <el-row>
            <el-col :span="24">
              <el-form-item :label="$t('system.withdraw_type')" required prop="withdraw_type">
                <el-select v-model="form.withdraw_type" class="input-password" clearable :disabled="posWithdrawConfigLocked">
                  <el-option
                    v-for="(item,index) in withdrawTypeMap"
                    :key="index"
                    :label="item.label"
                    :value="item.value"
                  />
                </el-select>
              </el-form-item>
            </el-col>
            <el-col v-if="form.withdraw_type === 2" :span="24">
              <el-form-item :label="$t('merchant.withdrawal_account')" required prop="bank_no">
                <template slot="label">
                  <span>{{ $t('merchant.withdrawal_account') }}
                    <div style="font-size: 12px;color: #7A869E;;line-height: 1.5;">{{ $t('tips.cash_out_support_local_bank') }}</div> </span>
                </template>
                <el-select v-model="form.bank_no" class="input-password" clearable>
                  <el-option
                    v-for="(item,index) in accountList"
                    :key="index"
                    :label="item.settlement_bank + '-' + item.settlement_bank_account_num"
                    :value="item.bank_no"
                  />
                </el-select>
                <br>
                <span v-if="accountList.length === 0" style="color: #71110e;font-size: 12px;">
                  {{ $t('tips.not_bank_account') }}
                </span>
                <span v-if="accountList.length === 0" style="color: #3855f1;cursor: pointer;font-size: 12px;padding-left: 10px;" @click="$emit('changeComponent',{compName:'BankAccountList'})">Go to Add</span>
              </el-form-item>
            </el-col>
          </el-row>
          <template v-if="form.withdraw_type === 2">
            <el-row>
              <el-col :span="24">
                <el-form-item :label="$t('system.auto_withdraw_type')" required prop="auto_withdraw_type">
                  <!-- <el-radio-group v-model="form.auto_withdraw_type" clearable @change="onChangeGroup">
                    <el-radio
                      v-for="(item,index) in autoWithdrawTypeMap"
                      :key="index"
                      :label="item.value"
                    >{{ item.label }}</el-radio>
                   </el-radio-group> -->
                  <el-select v-model="form.auto_withdraw_type" class="input-password" clearable :disabled="posWithdrawConfigLocked" @change="onChangeGroup">
                    <el-option
                      v-for="(item,index) in autoWithdrawTypeMap"
                      :key="index"
                      :label="item.label"
                      :value="item.value"
                    />
                  </el-select>
                </el-form-item>
              </el-col>
            </el-row>
            <el-row v-if="form.auto_withdraw_type === 1">
              <!-- <div class="section-tip">
                 {{ $t('tips.withdraw_tip_day') }}
               </div> -->
              <el-col :span="24">
                <el-form-item :label="$t('data.withdrawal_period')" required prop="auto_withdraw_dates">
                  <el-select v-model="form.auto_withdraw_dates" class="input-password" clearable :disabled="posWithdrawConfigLocked">
                    <el-option
                      v-for="(item,index) in withdrawDayMap"
                      :key="index"
                      :label="item.label"
                      :value="item.value"
                    />
                  </el-select>
                  <template v-if="form.auto_withdraw_dates">
                    <div v-if="language === 'zh'" style="color: #AAB4C8;font-size:14px;">提交后下一个提现日期为{{ widthdrawalDate }}</div>
                    <div v-else style="color: #AAB4C8;font-size:14px;">The next cash-out date is {{ widthdrawalDate }} after submission.</div>
                  </template>
                </el-form-item>
              </el-col>
            </el-row>
            <el-row v-if="form.auto_withdraw_type === 2">
              <!-- <div class="section-tip" style="word-break: keep-all">
                 {{ $t('tips.withdraw_tip_amount') }}
               </div> -->
              <el-col :span="24">
                <el-form-item
                  prop="auto_withdraw_amount"
                  :rules="[
                    { required: true, message: 'Amount cannot be empty', trigger: 'blur'},
                    { validator: checkAmount, trigger: 'blur' }
                  ]"
                >
                  <template slot="label">
                    {{ $t('data.fixed_amount') }}
                    <el-tooltip placement="top">
                      <template slot="content">
                        <div style="max-width:300px;">{{ $t('tips.fixed_amount_tip') }}</div>
                      </template>
                      <svg-icon class-name="icon-function" style="width:15px;margin:0" icon-class="icon-blue-question" />
                    </el-tooltip>
                    <span v-if="isCurCountryID" style="font-size: 10px;"> ({{ $t('data.cash_out_amount_should') }} ≥ {{ form.withdraw_threshold | toDivideWithDot }})</span>
                  </template>
                  <el-input v-model="form.auto_withdraw_amount" type="text" class="input-password" placeholder="Enter amount" autocomplete="off" :disabled="posWithdrawConfigLocked" />
                </el-form-item>
              </el-col>
            </el-row>
          </template>

          <el-row v-if="$store.getters.isOpenMfa">
            <el-col :span="16">
              <el-form-item
                :label="$t('system.mfa_verify_code')"
                prop="verification_code"
                :rules="[{ validator: validateVerifyCode, trigger: ['blur', 'change'] }]"
                required
              >
                <el-input
                  v-model="form.verification_code"
                  maxlength="6"
                  class="input-password"
                  placeholder="Enter your MFA verification code"
                  autocomplete="off"
                  clearable
                />
              </el-form-item>
            </el-col>
          </el-row>

        </el-form>
        <div slot="footer" class="dialog-footer">
          <el-button @click="dialogVisible = false">{{ $t('components.cancel') }}</el-button>
          <el-button type="info" class="btn-submit" :disabled="listLoading" @click="submitModify('form')">{{ $t('components.submit') }}</el-button>
        </div>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import { updateWithdrawType, fetchWithdrawFee, fetchWithdrawType, fetchPosSpecialWithdraw } from '@/api/system/system'
import { withdrawTypeMap, autoWithdrawTypeMap } from '@/utils/maps'
import { mapState } from 'vuex'
import dayjs from 'dayjs'
import store from '@/store'
import { bankQueryList, getWithdrawThreshold } from '@/api/merchant-manage/merchant-manage'
export default {
  name: 'ModifyPwdModal',
  data() {
    this.checkAmount = (rule, value, callback) => {
      const toDivideWithDot = this.$options.filters['toDivideWithDot']
      const toDivide100 = this.$options.filters['toDivide100']
      const toThousandFilter = this.$options.filters['toThousandFilter']
      value = Number(value)
      if (this.withdraw_fee_status === 1) {
        if (value <= 12) {
          return callback(new Error(`Amount greater than ${this.withdraw_fee / 100}`))
        }
      }

      if (value > 100000000) {
        return callback(new Error('The maxmum amount is 100 million'))
      }
      if (value <= 0 || isNaN(value)) {
        return callback(new Error('Please enter a non-negative number'))
      }
      if (!/^(0|[1-9]\d*)(\.\d{1,2})?$/.test(value)) {
        return callback(new Error('Please enter two decimal places'))
      }
      if (value > this.balance) {
        return callback(new Error('Insufficient balance!'))
      }
      if (this.isCurCountryID) {
        if (value < toDivide100(this.withdrawSettings.withdraw_threshold)) {
          return callback(new Error('Cash Out Amount should be greater than or equal to ' + toDivideWithDot(this.withdrawSettings.withdraw_threshold)))
        }
      } else {
        if (value > 1000000) {
          return callback(new Error('The maxmum amount is 1 million'))
        }
      }
      if (this.currentWithdrawThreshold && value < this.currentWithdrawThreshold) {
        return callback(new Error(`Cashout Threshold: ${toThousandFilter(this.currentWithdrawThreshold)}${this.$store.getters.currency}`))
      }
      this.$commonFn.validateFormAmount({ rule, value, callback })
      callback()
    }
    this.validateVerifyCode = (rule, value, callback) => {
      if (!value) {
        return callback(new Error('Please input MFA Verification Code'))
      }
      if (value.includes(' ')) {
        return callback(new Error('Please do not enter spaces'))
      }
      if (value.length !== 6 || !/^\d+$/.test(value)) {
        return callback(new Error('Please enter 6 digit valid MFA Verification code'))
      }
      return callback()
    }
    return {
      bank_country_code: '',
      dialogVisible: false,
      listLoading: false,
      accountList: [],
      posWithdrawSpecial: false,
      form: {
        withdraw_type: null,
        auto_withdraw_type: null,
        auto_withdraw_amount: null,
        verification_code: null
      },
      withdraw_fee: null,
      withdraw_fee_status: null,
      withdrawSettings: {},
      countryWithdrawThresholds: {
        RU: 4300000
      }
    }
  },
  computed: {
    ...mapState('app', ['language']),
    // MX POS 特殊提现商户：提现配置由系统托管，弹窗内相关字段只读（与运营后台「提现开关」弹窗同口径）
    posWithdrawConfigLocked() {
      return this.$store.getters.isMxMerchant && this.posWithdrawSpecial
    },
    isCurCountryID() {
      return this.$store.getters.curCountry.country_code === 'ID'
    },
    currentWithdrawThreshold() {
      return this.countryWithdrawThresholds[this.$store.getters.curCountry.country_code] || 0
    },
    withdrawTypeMap() {
      return withdrawTypeMap()
      // label: this.$t('map.settlement_type_1')
    },
    widthdrawalDate() {
      const val = this.form.auto_withdraw_dates || 0
      return dayjs().add(val, 'day').format('YYYY-MM-DD')
    },
    autoWithdrawTypeMap() {
      return autoWithdrawTypeMap()
    },
    withdrawDayMap() {
      const arr = []
      for (let i = 1; i <= 30; i++) {
        arr.push({
          value: i,
          label: 'D+' + i }
        )
      }
      return arr
    }
  },
  created() {
    store.dispatch('user/getInfo').then(res => {
      this.bank_country_code = res.country_code
      this.getAccountList()
    })
    this.getWithdrawFee()
    if (this.isCurCountryID) {
      this.getWithdrawType()
    }
    if (this.$store.getters.isMxMerchant) {
      // 接口异常或被拦截时按非特殊商户处理（与改造前行为一致，不阻断商户正常操作）
      fetchPosSpecialWithdraw().then(res => {
        this.posWithdrawSpecial = !!res.data
      }).catch(() => {
        this.posWithdrawSpecial = false
      })
    }
    this.getWithdrawThreshold()
  },
  methods: {
    getWithdrawThreshold(){
      getWithdrawThreshold().then(res=>{
        const toDivide100 = this.$options.filters['toDivide100']
        const { withdraw_threshold, country_code } = res.data
        this.countryWithdrawThresholds = {
          [country_code]: toDivide100(withdraw_threshold)
        }
      })
    },
    getWithdrawType() {
      fetchWithdrawType().then(res => {
        const { data } = res || {}
        this.withdrawSettings = data
      })
    },
    getAccountList() {
      bankQueryList({ auditStatus: 2, usedStatus: 1, settlement_type: 1 }).then(res => {
        const data = res.data || []
        this.accountList = data.filter(i => i.audit_status === 2 && (i.bank_country_code === this.bank_country_code || this.bank_country_code === 'HK-USD'))
      })
    },
    changeModalStatus(value) {
      this.dialogVisible = value.status
      this.form = { ...value.data }
      this.$nextTick(() => {
        this.$refs['form'].clearValidate(['verification_code'])
      })
    },
    handleDialogClose() {
      this.$refs['form'].clearValidate()
    },
    onChangeGroup() {
      this.$refs['form'].clearValidate(['auto_withdraw_dates',
        'auto_withdraw_amount', 'verification_code'])
    },
    getWithdrawFee() {
      fetchWithdrawFee().then(res => {
        const { withdraw_fee, withdraw_fee_status } = res.data
        this.withdraw_fee = withdraw_fee
        this.withdraw_fee_status = withdraw_fee_status
      })
    },
    submitModify(formName) {
      this.$refs[formName].validate((valid) => {
        if (valid) {
          this.$confirm(this.$t('tips.whether_to_submit'), this.$t('components.tips'), {
            confirmButtonText: this.$t('components.confirm'),
            cancelButtonText: this.$t('components.cancel'),
            type: 'warning'
          }).then(() => {
            this.listLoading = true
            const { withdraw_type, auto_withdraw_type, auto_withdraw_amount, auto_withdraw_dates, verification_code, bank_no } = this.form
            const params = { withdraw_type, mfa_code: verification_code, bank_no, timestamp: Date.now() }

            // 自动
            if (withdraw_type === 2) {
              params.auto_withdraw_type = auto_withdraw_type
              if (auto_withdraw_type === 1) { // 日期
                params.auto_withdraw_dates = auto_withdraw_dates
              }
              if (auto_withdraw_type === 2) { // 金额
                params.auto_withdraw_amount = this.$commonFn.mathMultiply(auto_withdraw_amount, 100)
              }
            }
            const paramsData = {}
            const aesKey = this.$commonFn.generateRandomString()
            const aesIV = this.$commonFn.generateRandomString()
            const aesKeyIv = JSON.stringify({ key: aesKey, iv: aesIV })
            paramsData.key = this.$commonFn.rsaEncrypt(aesKeyIv)
            paramsData.param = this.$commonFn.cryptoJSAesEncrypt(JSON.stringify(params), aesKey, aesIV)
            paramsData.sign = this.$commonFn.rsaSign(JSON.stringify(params))
            updateWithdrawType(paramsData).then(res => {
              this.$message.success('Success')
              this.$emit('submit')
              this.dialogVisible = false
            }).finally(() => {
              this.listLoading = false
            })
          })
        }
      })
    }
  }
}
</script>

<style scoped>
.input-password{
  width: 300px;
}
.modify-password{
    /* margin: 0 10px 0 50px; */
}
.dialog-footer{
  text-align: right;
}
.pos-withdraw-lock-tip {
  margin-bottom: 16px;
  padding: 8px 12px;
  border: 1px solid #faecd8;
  border-radius: 4px;
  background: #fdf6ec;
  color: #e6a23c;
  font-size: 13px;
  line-height: 20px;
}
</style>
